import { SUPPORT_VOTED_TOPICS } from '@sv-support-sdk/utils/src/constants/articles';
import { topicsSorting } from '@sv-support-sdk/utils/src/helpers/topicsSorting';
import { tableRender } from '@sv-support-sdk/utils/src/helpers/table';
import { iframeRender } from '@sv-support-sdk/utils/src/helpers/iframe';
import { templateRender } from '@sv-support-sdk/utils/src/helpers/templates';
import { Common } from '@sv-support-sdk/shared-types';

import { TThunk } from '../../..';
import { helpCenterActions } from '../../../config';

export const getCategories = (): TThunk => async (dispatch, getState, api) => {
  const {
    helpCenter: { categories, loading },
  } = getState();

  if (loading.categories || categories.length) return;

  try {
    dispatch(helpCenterActions.setCategoriesLoading(true));

    const { data } = await api.helpCenter.getCategories({ per_page: 1000 });

    const res = data.sort(topicsSorting);

    dispatch(helpCenterActions.setCategories(res));
  } finally {
    dispatch(helpCenterActions.setCategoriesLoading(false));
  }
};

export const getTopics =
  ({ noteTitle, tipTitle }: { noteTitle?: string; tipTitle: string }): TThunk =>
  async (dispatch, getState, api) => {
    const {
      helpCenter: { topics, loading },
    } = getState();

    if (loading.topics || Object.keys(topics).length) return;

    try {
      dispatch(helpCenterActions.setTopicsLoading(true));

      const { data } = await api.helpCenter.getTopics();

      const res = data.reduce(
        (
          acc: { [key: string]: Common.HelpCenter.IHelpCenterTopic[] },
          el: Common.HelpCenter.IHelpCenterTopic,
        ) => {
          const topic: Common.HelpCenter.IHelpCenterTopic = {
            ...el,
            description: iframeRender(
              tableRender(
                templateRender(el.description, {
                  noteTitle,
                  tipTitle,
                }),
              ),
            ),
          };
          const category = acc[topic.categorySlug];
          // eslint-disable-next-line no-param-reassign
          acc[topic.categorySlug] = category ? [...category, topic] : [topic];
          return acc;
        },
        {},
      );

      dispatch(helpCenterActions.setTopics(res));
    } finally {
      dispatch(helpCenterActions.setTopicsLoading(false));
    }
  };

interface ISendUsefulParams {
  topic: Common.HelpCenter.IHelpCenterTopic;
  flag: number;
}

export const sendUsefulTopic =
  ({ topic, flag }: ISendUsefulParams): TThunk =>
  async (dispatch, _, api) => {
    const { id, slug, useful, usefulClicks, categorySlug } = topic;

    dispatch(
      helpCenterActions.updateTopic({
        id,
        useful: +flag + useful,
        usefulClicks: usefulClicks + 1,
        categorySlug,
      }),
    );
    dispatch(helpCenterActions.voteTopic(slug));

    // @ts-expect-error JSON.parse can handle null value
    const voted = JSON.parse(localStorage.getItem(SUPPORT_VOTED_TOPICS)) || [];
    localStorage.setItem(SUPPORT_VOTED_TOPICS, JSON.stringify([...voted, slug]));

    await api.helpCenter.sendUseful(slug, { flag });
  };
